import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame } from "lucide-react";

export function TensionMeter({ gameId, drawnCount, stage }) {
  const [t, setT] = useState({ one_away: 0, ready: 0 });

  useEffect(() => {
    if (!gameId) return;
    api.get(`/games/${gameId}/tension`).then((r) => setT(r.data)).catch(() => {});
  }, [gameId, drawnCount, stage]);

  const hot = t.one_away > 0 || t.ready > 0;
  return (
    <div data-testid="tension-meter"
         className={`p-4 rounded-2xl border transition-colors duration-500 ${
           hot ? "bg-[#FF007F]/10 border-[#FF007F]/50 shadow-[0_0_30px_-10px_rgba(255,0,127,0.7)]" : "bg-[#12141D] border-white/10"}`}>
      <div className="text-xs uppercase tracking-widest text-slate-400 flex items-center gap-1">
        <Flame className={`w-3 h-3 ${hot ? "text-[#FF007F] animate-pulse" : ""}`} /> Spanning
      </div>
      <div className="mt-1 flex items-baseline gap-2">
        <span data-testid="tension-one-away" className={`text-4xl font-black ${hot ? "text-[#FF007F]" : "text-slate-500"}`}>{t.one_away}</span>
        <span className="text-sm text-slate-300">speler{t.one_away === 1 ? "" : "s"} nog 1 nummer van bingo</span>
      </div>
      {t.ready > 0 && (
        <div data-testid="tension-ready" className="mt-1 text-xs font-bold text-[#00E676] animate-pulse">
          {t.ready} kaart{t.ready === 1 ? " heeft" : "en hebben"} al bingo!
        </div>
      )}
    </div>
  );
}
